export default __webpack_public_path__ + "static/media/earth_rune.4c7e636e.svg";